import { ICustomViewTableOptions } from "csi/middleware/customView/options/CustomViewOptions";
import { ICustomViewTableDropDownOptions } from "csi/middleware/customView/options/CustomViewOptions";
import { ComponentItem } from "designSystem/types/component-item-types";

export enum SecondaryDisplayType {
	SECONDARY_DISPLAY_DISABLE  = "0",
	SECONDARY_DISPLAY_TYPE_COLUMN  = "1",
	SECONDARY_DISPLAY_TYPE_ROW  = "2",
}

export interface ICustomViewSecondaryDisplayOptions extends ICustomViewTableOptions {
	/** secondary display type (0,1,2) for disable, column or row */
	secondaryDisplayType?: SecondaryDisplayType;
}

export interface ICustomViewSecondaryDisplayDropDownOptions extends ICustomViewTableDropDownOptions {
	/** secondary display type dropdown options */
	readonly secondaryDisplayTypeOptions: ComponentItem[];
}